import React, {Component} from 'react';
import './App.css';








  class ConservationMap extends Component {
    render() {
      return (
        <div className="box">
          <img alt="Map" style={{ width: "300px" }} src={this.props.currentNote.body} />
          <h1>{this.props.currentNote.title} <a href={this.props.currentNote.body} target="_blank"> <br/>View Map</a></h1>
        </div>
      );
    }
  }

  const Note = ({ note, setCurrentNote }) => {
    const handleClick = () => {
      setCurrentNote(note);
    };
    return (
        <a onClick={handleClick}>
          <li className={note.color}>
        
              <div className="note-title">{note.title}</div>
            
          </li>
        </a>
     
    );
  };

  const NoteList = props => {
    const noteIds = Object.keys(props.notes);
    return (
      <div>

        <ul className="maps">
          {noteIds.map(noteId => (
            <Note
              note={props.notes[noteId]}
              key={noteId}
              setCurrentNote={props.setCurrentNote}
            ></Note>
          ))}
        </ul>
      </div>
    );
  };

  const Main = props => {
    return (
      <main className="main_in">

          <article className="section_in">
            <NoteList
              notes={props.notes}
              setCurrentNote={props.setCurrentNote}
            ></NoteList>
          </article>

          <aside className="aside_in">
            <ConservationMap currentNote={props.currentNote} ></ConservationMap>
          </aside>
      
      </main>
    );
  };

  class App extends Component {
    constructor(props) {
      super(props);
      this.setCurrentNote = this.setCurrentNote.bind(this);
      this.state = {
        notes: {
          'map-1': {
            id: "1",
            title: "Bigalk Trout Stream Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/bigalk_layout.jpg",
            color: 'pink',
          },

          'map-2': {
            id: "note-2",

            title: "Kleckner Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/kleckner_layout.jpg",
           

            color: 'blue',
          },

          'map-3': {
            id: "note-6",

            title: "Souhrada Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/souhradawild_layout.jpg",
          
            color: 'blue',
          },
          'map-4': {
            id: "note-4",
            title: "Bonair Shooting Range",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/bonair_layout.jpg",
            color: 'pink',
          },
          'map-5': {
            id: "note-5",
        
            title: "Lubbert Park",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/lubbert_layout.jpg",
            color: 'blue',
          },
          'map-6': {
            id: "note-5",
            title: "Souhrada Forest",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/souhradaforest_layout.jpg",
            
            color: 'pink',
          },

          'map-7': {
            id: "note-5",

            title: "Crane Creek Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/cranecreek_layout.jpg",

            color: 'blue',
          },


          ///

          'map-8': {
            id: "8",
            title: "Lylah's Marsh",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/lylah_layout.jpg",
            color: 'pink',
          },

          'map-9': {
            id: "note-9",

            title: "Turkey Bend Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/turkeybend_layout.jpg",
           
            color: 'blue',
          },

          'map-10': {
            id: "note-10",

            title: "Cleghorn Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/cleghorn_layout.jpg",

            color: 'blue',
          },
          'map-11': {
            id: "note-11",
            title: "Lake Hendricks",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/lakehendricks_layout.jpg",
            color: 'pink',
          },
          'map-12': {
            id: "note-12",

            title: "Taylor's Pond Park",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/taylor_layout.jpg",
         
            color: 'blue',
          },
          'map-13': {
            id: "note-13",

            title: "Dieken Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/dieken_layout.jpg",


            color: 'pink',
          },

          'map-14': {
            id: "note-14",


            title: "Lidtke Park",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/lidtke_layout.jpg",
        
           
            color: 'blue',
          },



          'map-15': {
            id: "15",
            title: "Thomson Marsh",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/thomson_layout.jpg",
            color: 'pink',
          },

          'map-16': {
            id: "note-16",

            title: "Evans-Hughes Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/evanshughes_layout.jpg",
           
            color: 'blue',
          },

          'map-17': {
            id: "note-17",
            title: "Mullen Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/mullen_layout.jpg",
            color: 'blue',
          },
          'map-18': {
            id: "note-18",

            title: "Upper Iowa River Access",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/upperiowa_layout.jpg",
           
            color: 'pink',
          },
          'map-19': {
            id: "note-19",

            title: "Florenceville Park",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/florenceville_layout.jpg",
           
            color: 'blue',
          },
          'map-20': {
            id: "note-20",

            
            title: "Meiricks Pond Access",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/meirick_layout-1.jpg",

           
          
            color: 'pink',
          },

          'map-21': {
            id: "note-21",
            title: "Vernon Springs Park/Turkey River",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/vernon_turkey_layout.jpg",
            color: 'blue',
          },


          ///

          'map-22': {
            id: "22",

            title: "Hart Pond Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/hart_layout-1.jpg",
           
            color: 'pink',
          },

          'map-23': {
            id: "note-23",
            title: "Martinek Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/martinek_layout.jpg",
           
         
            color: 'blue',
          },

          'map-24': {
            id: "note-24",

            title: "Wittenbreer Marsh",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/wittenbreer_layout.jpg",
          
            color: 'blue',
          },
          'map-25': {
            id: "note-25",

            title: "Joachim Woods Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/03/joachim_layout.jpg",
       
            color: 'pink',
          },
          'map-26': {
            id: "note-26",

            title: "Reis Wildlife Area",
            body: "https://howardcounty.iowa.gov/mt-content/uploads/2020/09/reis_layout.jpg",
         
           
            color: 'blue',
          },
    
        },
        currentNote: {
          id: null,
          title: 'Conservation Maps',
          body: 'https://howardcounty.iowa.gov/mt-content/uploads/2020/03/howardcountymap_layout.jpg',
          color: '',
        },
      };
    }

    setCurrentNote(note) {
      this.setState({ currentNote: note });
    }
    render() {
      return (
      
          <Main
            notes={this.state.notes}
            currentNote={this.state.currentNote}
            setCurrentNote={this.setCurrentNote}
          ></Main>
       
      );
    }
  }


export default App;









